;(function () {
  const components = {
    instantSearchFocus: SAXX.Init.Component((node, ctx) => {
      ctx.on(SAXX.Events.DrawerControlInteraction, (_, details) => {
        if (
          details?.controlElement &&
          details?.controlElement === 'site-search'
        ) {
          setTimeout(() => {
            node.querySelector('[name="q"]').focus({ preventScroll: true })
            node.querySelector('[name="q"]').value = ''
            node.querySelector('.instant-search--results-container').innerHTML =
              ''
          }, 1)
        }
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
